import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { MonthlyReportTitle } from '@/features/payment-management/affiliate-log/monthly-report/components/MonthlyReportTitle';
import { useGetMonthlyReport } from '@/features/payment-management/affiliate-log/monthly-report/hooks/useGetMonthlyReport';
import { MonthlyReportTable } from '@/features/payment-management/affiliate-log/monthly-report/table';
import { FileIcon } from '@/icons';
import { AffiliateWithdrawStatus } from '@/services/payment/payment.types';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'requestId',
    'createdDate',
    'bankType',
    'bankName',
    'accountSymbol',
    'accountNumber',
    'accountName',
    'requestedAmount',
    'status',
    'remarks',
  ]),
  desc: z.boolean(),
});

const monthlyReportSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z.union([z.string(), z.array(z.string())]).optional(),
  /** "start,end" (ms) of the month clicked in the list; bounds the date filter. */
  month: z.string().optional(),
  status: z.nativeEnum(AffiliateWithdrawStatus).optional().catch(undefined),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/payment-management/affiliate-log/$monthly-report')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => monthlyReportSearchSchema.parse(search),
  loader: () => ({
    crumb: <CrumbTitle id="paymentManagement.affiliatePaymentLogs.monthlyReport.crumb.title" icon={FileIcon} />,
    title: <MonthlyReportTitle />,
  }),
});

function RouteComponent() {
  const { monthlyReportData, isLoading, pagination, monthBounds } = useGetMonthlyReport();

  return (
    <MonthlyReportTable
      data={monthlyReportData}
      pagination={pagination}
      loading={isLoading}
      monthBounds={monthBounds}
    />
  );
}
